import styled from '@emotion/styled';

/**
 * ImpactMetric — 1 métrique impact (emoji + valeur + label).
 * Utilisé en ligne dans la carte impact de l'écran Bravo.
 */

export default function ImpactMetric({ emoji, value, label }) {
  return (
    <Wrap>
      {emoji && <Emoji aria-hidden="true">{emoji}</Emoji>}
      <Value>{value}</Value>
      <Label>{label}</Label>
    </Wrap>
  );
}

const Wrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 4px;
  min-width: 0;
`;

const Emoji = styled.div`
  font-size: 24px;
  line-height: 1;
  margin-bottom: 4px;
`;

const Value = styled.div`
  font-size: 17px;
  font-weight: 800;
  color: ${p => p.theme.palette.text.primary};
  font-family: ${p => p.theme.typography.fontFamily};
  letter-spacing: -0.3px;
`;

const Label = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: ${p => p.theme.palette.text.secondary};
  text-transform: uppercase;
  letter-spacing: 1.2px;
  font-family: ${p => p.theme.typography.fontFamily};
  line-height: 1.3;
`;
